var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import ExpEditor from '@shared/expression/ExpEditor';
import { useLanguage } from '@base/LanguageProvider';
import { useTagActions } from '@data/tag/tagActions';
import { useExpSearchables } from '@data/hooks/expSearchables';
import { startGlobalLoading, stopGlobalLoading } from '@shared/loading/globalLoading';
function ExpressionToolbar(_a) {
    var _this = this;
    var _b;
    var accountTag = _a.accountTag, invalidateTable = _a.invalidateTable;
    var L = useLanguage().L;
    var searchables = useExpSearchables();
    var editTag = useTagActions().editTag;
    var tagExp = (_b = accountTag === null || accountTag === void 0 ? void 0 : accountTag.expression) !== null && _b !== void 0 ? _b : '';
    var done = function (expression) { return __awaiter(_this, void 0, void 0, function () {
        var updatedTag;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!accountTag || expression === tagExp) {
                        return [2 /*return*/];
                    }
                    updatedTag = __assign({}, accountTag);
                    startGlobalLoading();
                    updatedTag.expression = expression || null;
                    return [4 /*yield*/, editTag(updatedTag)];
                case 1:
                    _a.sent();
                    invalidateTable();
                    stopGlobalLoading();
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { style: { width: '100%', paddingLeft: '15px' } },
        React.createElement(ExpEditor, { style: { width: '100%', height: '40px' }, showBtns: true, done: done, expression: tagExp, searchables: searchables, placeholder: accountTag ? L('Enter formula here') : ' ', isReadOnly: accountTag ? false : true, accTagId: accountTag === null || accountTag === void 0 ? void 0 : accountTag.id })));
}
export default ExpressionToolbar;
